exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error-message[data-v-2ce05cf2] {\n  color: #ff0000;\n  font-size: 16px;\n  margin: 20px auto 120px 20px;\n  text-align: left;\n}\n", ""]);

// exports
